import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import pt from 'date-fns/locale/pt';
import Titulo from '../../comum/Titulo';
import { getFinanceiroAgencia, getFinanceiroEmpresa, PERFIL_ADMIN } from '../../../security/securityContext';
import Autorizacao, { validaPerfis } from '../../../security/Autorizacao';
import buscarEmpresas from '../../../actions/empresa/buscarEmpresas';
import axios from 'axios';
import { SLOW_REQUEST_CONFIG } from '../../../util/loadingUtil';
import { URL } from '../../../util/ambienteActions';
import moment from 'moment';
import Select from 'react-select';
import DatePicker from 'react-datepicker/es';
import { renderFieldCheck } from '../../../util/inputs';
import { ITEM_TODAS_EMPRESAS } from '../../../util/constantsUtil';
import buscarAgenciaEmpresa from '../../../actions/agencia/buscarAgenciaEmpresa';

registerLocale('pt', pt);
setDefaultLocale('pt');

export class PainelRelatorioGerencialAgencia extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tipoRelatorio: 'EMPRESA',
            tipoDataBusca: 'tipoDataVenda',
            empresasSelecionadas: [],
            agenciasSelecionadas: []            
        };
        this.handleChangeTipoBusca = this.handleChangeTipoBusca.bind(this);
    }

    componentDidMount() {
        this.props.buscarAgenciaEmpresa(this.props.empresaSelecionada.id);
        if (!validaPerfis([PERFIL_ADMIN])) {
            this.setState({ empresasSelecionadas: [{ label: this.props.empresaSelecionada.nomeFantasia, value: this.props.empresaSelecionada.id }, ...this.state.empresasSelecionadas] });
            this.props.buscarEmpresas(this.props.empresaSelecionada.id);
        } else {            
            this.props.buscarEmpresas();
        }
    }

    possuiPerfilVerComboxAgencia() {
        return validaPerfis([PERFIL_ADMIN]) || validaPerfis([getFinanceiroEmpresa(this.props.empresaSelecionada.id)])
    }

    buscar(values) {
        if (values.resumido) {
            this.emitirRelatorioGerencialResumido(values)
        } else {
            this.emitirRelatorioGerencial(values)
        }

    }

    retornaTodasEmpresas() {
        const empresasMapeadas = this.props.empresas.map(elemento => ({
            label: elemento.nomeFantasia,
            value: elemento.id
        }));

        if (validaPerfis([PERFIL_ADMIN])) {
            return [...empresasMapeadas, ITEM_TODAS_EMPRESAS];
        }

        return [...empresasMapeadas];
    }

    retornaTodasAgencias() {
      const agencias = this.props.agenciasEmpresa.map(elemento => ({
            label: elemento.valor,
            value: elemento.chave
        }));

        return [...agencias, ITEM_TODAS_EMPRESAS]
    }

    exibirComboEmpresas() {
        return (
            <div>
                <Select
                    noOptionsMessage={() => ('Nenhuma opção encontrada')}
                    value={this.state.empresasSelecionadas}
                    isMulti
                    placeholder='Selecione...'
                    styles={{
                        control: base => ({
                            ...base,
                            minHeight: 32,
                            fontSize: 16,
                            width: '100%',
                            borderColor: '#e4e7ea',
                            cursor: 'pointer'
                        })
                    }}
                    options={this.retornaTodasEmpresas()}
                    onChange={event => this.setState({ empresasSelecionadas: [...event] })}
                />
            </div>
        )
    }

    exibirComboAgenciasEmpresa() {
        return (
            <div>
                <Select
                    noOptionsMessage={() => ('Nenhuma opção encontrada')}
                    value={this.state.agenciasSelecionadas}
                    isMulti
                    placeholder='Selecione...'
                    styles={{
                        control: base => ({
                            ...base,
                            minHeight: 32,
                            fontSize: 16,
                            width: '100%',
                            borderColor: '#e4e7ea',
                            cursor: 'pointer'
                        })
                    }}
                    options={this.retornaTodasAgencias()}
                    onChange={event => this.setState({ agenciasSelecionadas: [...event] })}
                />
            </div>
        )
    }

    async emitirRelatorioGerencialResumido(values) {
        const ehEncomenda = values.encomenda ? values.encomenda : false;
        let arquivo = 'Empresa;Grupo;Mês/Ano;Situação;Quantidade;Valor Total;Valor Imposto;Cupom(Qtd. Utilizada);Tarifa Seguro\n';

        let url = `${URL}/relatorio-gerencial-agencia/resumido?dataInicio=${moment(this.state.dataInicio)
            .format('YYYY-MM-DD')}&dataFim=${moment(this.state.dataFim)
                .format('YYYY-MM-DD')}&tipoBusca=${this.state.tipoDataBusca}&ehEncomenda=${ehEncomenda}`;
        
        if (this.state.tipoRelatorio === 'EMPRESA') {

            if (this.state.empresasSelecionadas.length == 1 && this.state.empresasSelecionadas[0].label === ITEM_TODAS_EMPRESAS.label) {
                url = `${url}&empresaId=${this.props.empresaSelecionada.id}&empresas=${this.props.empresas.map(it => it.id)
                    .join(',')}`;
            } else {
                url = `${url}&empresaId=${this.props.empresaSelecionada.id}&empresas=${this.state.empresasSelecionadas.map(it => it.value)
                    .join(',')}`;
            }
        }

        if (this.state.agenciasSelecionadas.length == 1 && this.state.agenciasSelecionadas[0].label === ITEM_TODAS_EMPRESAS.label) {
            url = `${url}&agencias=${this.props.agenciasEmpresa.map(it => it.chave).join(',')}`
        } else {
            url = `${url}&agencias=${this.state.agenciasSelecionadas.map(it => it.value).join(',')}`
        }

        let retorno = await axios.get(url, SLOW_REQUEST_CONFIG);

        arquivo = `${arquivo}${retorno.data.map(it => {

            let situacao = ehEncomenda ? it.situacaoPedido : it.situacaoReserva;
            let grupo = it.grupo ? it.grupo : ' - '

            let valor = `"${it.nomeEmpresa}";"${grupo}";"${it.mesAno}";"${situacao}";${it.quantidade};"${it.valorTotal}";"${it.valorTotalImposto}";"${it.qtdCupomUtilizado}";"${it.valorTotalTarifaSeguro}"`

            return valor;
        }).join('\n')}\n`;

        this.executarDownload(arquivo)
    }

    async emitirRelatorioGerencial(values) {               
        const ehEncomenda = values.encomenda ? values.encomenda : false;

        let arquivo = '';
        if (ehEncomenda) {
            arquivo = 'Número pedido;Número Encomenda;Volumes;Nome empresa;Nome fantasia empresa;Nome agência;Situação;Nome remetente;'
        } else {
            arquivo = 'Número pedido;Número bilhete;Número seguro;Nome empresa;Nome fantasia empresa;Nome agência;Situação;Nome passageiro;'
        }

        if (validaPerfis([PERFIL_ADMIN]) && !ehEncomenda) {
            arquivo += 'Telefone passageiro; ';
        }
        arquivo += 'Custo cancelamento;Custo remarcação;Comissão;Imposto;'
        if (ehEncomenda) {
            arquivo += 'Valor encomenda;Valor Seguro;Valor Total;'
        } else {
            arquivo += 'Tarifa Seguro;Desconto;Acrescimo;Acrescimo(%);Taxa embarque;'
        }

        if (validaPerfis([PERFIL_ADMIN])) {
            arquivo += 'Taxa serviço;'
        }

        arquivo += 'Pedágio;'

        if (!ehEncomenda) {
            arquivo += 'Valor passagem( - Desconto );Cupom(%);Descrição Cupom;'
        }

        arquivo += 'Valor pedido;'

        if (this.state.tipoRelatorio === 'EMPRESA') {
            arquivo += 'Líquido empresa;'
        }

        arquivo += 'Vendedor;E-mail vendedor;Nome cliente;Data compra;Data da Transação;Rota;Data de partida;'

        if (ehEncomenda) {
            arquivo += 'Trecho de origem;Trecho de destino;Tipo de pagamento;Prestador;Veículo\n';
        } else {
            arquivo += 'Data embarque;Trecho de origem;Trecho de destino;Número da Poltrona;Tipo de pagamento;Tipo de emissão;Prestador;Veículo;API;Emissão BPe\n';
        }

        let url = `${URL}/relatorio-gerencial-agencia?dataInicio=${moment(this.state.dataInicio)
            .format('YYYY-MM-DD')}&dataFim=${moment(this.state.dataFim)
                .format('YYYY-MM-DD')}&tipoBusca=${this.state.tipoDataBusca}&ehEncomenda=${ehEncomenda}`;
        
        if (this.state.tipoRelatorio === 'EMPRESA') {
            if (this.state.empresasSelecionadas.length == 1 && this.state.empresasSelecionadas[0].label === ITEM_TODAS_EMPRESAS.label) {
                url = `${url}&empresaId=${this.props.empresaSelecionada.id}&empresas=${this.props.empresas.map(it => it.id)
                    .join(',')}`;

            } else {
                url = `${url}&empresaId=${this.props.empresaSelecionada.id}&empresas=${this.state.empresasSelecionadas.map(it => it.value)
                    .join(',')}`;
            }
        }

        if (this.state.agenciasSelecionadas.length == 1 && this.state.agenciasSelecionadas[0].label === ITEM_TODAS_EMPRESAS.label) {
            url = `${url}&agencias=${this.props.agenciasEmpresa.map(it => it.chave).join(',')}`
        } else {
            url = `${url}&agencias=${this.state.agenciasSelecionadas.map(it => it.value).join(',')}`
        }

        let count = 0;
        let qtd = await this.recuperarQtdRegistros(ehEncomenda);
        let totalParticoes = Math.ceil(qtd / 5000);
        for (let start = 0; start < totalParticoes; start += 1) {
            let retorno = await this.downloadParte(url, start);
            arquivo = `${arquivo}${retorno.map(it => {
                let valor = '';
                let prestador = it.prestador ? it.prestador : ' - ';
                let porcentagemCupom = it.porcentagemCupom ? it.porcentagemCupom : '0';
                if (ehEncomenda) {
                    valor = `${it.numeroPedido};${it.numeroEncomenda};"${it.volumeEncomenda}";"${it.nomeEmpresa}";"${it.nomeFantasiaEmpresa}";"${it.nomeAgencia}";${it.situacao};"${it.nomeRemetente}";`
                } else {
                    valor = `${it.numeroPedido};${it.numeroReserva};${it.numeroSeguro};"${it.nomeEmpresa}";"${it.nomeFantasiaEmpresa}";"${it.nomeAgencia}";${it.situacao};"${it.nomePassageiro}";`
                }

                if (validaPerfis([PERFIL_ADMIN]) && !ehEncomenda) {
                    valor += `"${it.telefonePassageiro ? it.telefonePassageiro : ' - '}";`;
                }
                valor += `"${it.custoCancelamento}";"${it.custoRemarcacao}";"${it.comissao}";"${it.imposto}";`
                if (ehEncomenda) {
                    valor += `"${it.valorEncomenda}";"${it.valorSeguroEncomenda}";"${it.valorTotalEncomenda}";`
                } else {
                    valor += `"${it.tarifaSeguro}";"${it.desconto}";"${it.acrescimo}";"${it.percentualAcrescimo}";"${it.taxaEmbarque}";`
                }

                if (validaPerfis([PERFIL_ADMIN])) {
                    valor += `"${it.taxaServico}";`
                }

                valor += `"${it.pedagio}";`

                if (!ehEncomenda) {
                    valor += `"${it.valorPassagem}";"${porcentagemCupom}";"${it.descricaoCupom}";`
                }

                valor += `"${it.valorPedido}";`

                if (this.state.tipoRelatorio === 'EMPRESA') {
                    valor += `"${it.valorLiquido}";`
                }
                valor += `"${it.vendedor}";"${it.email}";"${it.nomeCliente}";"${it.dataCompra}";"${it.dataHoraHistorico}";"${it.rota}";"${it.dataPartida}";`
                if (ehEncomenda) {
                    valor += `"${it.trechoOrigem}";"${it.trechoDestino}";"${it.tipoPagamento}";"${prestador}";"${it.descricaoVeiculo}"`;
                } else {
                    valor += `"${it.dataEmbarque}";"${it.trechoOrigem}";"${it.trechoDestino}";"${it.numeroPoltrona}";"${it.tipoPagamento}";"${it.tipoEmissao}";"${prestador}";"${it.descricaoVeiculo}";"${it.api}";"${it.bpeEmitido}"`;
                }

                return valor;
            }).join('\n')}\n`;

            count += 1;
            if (count === totalParticoes) {
                this.executarDownload(arquivo)
            }
        }
    }

    async recuperarQtdRegistros(ehEncomenda) {
        let urlQtdRegistros = `${URL}/relatorio-gerencial-agencia/quantidade-registros?dataInicio=${moment(this.state.dataInicio)
            .format('YYYY-MM-DD')}&dataFim=${moment(this.state.dataFim)
                .format('YYYY-MM-DD')}&empresaId=${this.props.empresaSelecionada.id}&tipoBusca=${this.state.tipoDataBusca}&ehEncomenda=${ehEncomenda}`;
   
        if (this.state.tipoRelatorio === 'EMPRESA') {
            if (this.state.empresasSelecionadas.length == 1 && this.state.empresasSelecionadas[0].value === ITEM_TODAS_EMPRESAS.value) {
                urlQtdRegistros = `${urlQtdRegistros}&empresas=${this.props.empresas.map(it => it.id)
                    .join(',')}`;

            } else {
                urlQtdRegistros = `${urlQtdRegistros}&empresas=${this.state.empresasSelecionadas.map(it => it.value)
                    .join(',')}`;
            }
        }

        if (this.state.agenciasSelecionadas.length == 1 && this.state.agenciasSelecionadas[0].label === ITEM_TODAS_EMPRESAS.label) {
            urlQtdRegistros = `${urlQtdRegistros}&agencias=${this.props.agenciasEmpresa.map(it => it.chave).join(',')}`
        } else {
            urlQtdRegistros = `${urlQtdRegistros}&agencias=${this.state.agenciasSelecionadas.map(it => it.value).join(',')}`
        }


        let retorno = await axios.get(urlQtdRegistros, SLOW_REQUEST_CONFIG);
        return retorno.data;
    }

    async downloadParte(url, start) {
        let urlReq = `${url}&pagina=${start}`;
        let retorno = await axios.get(urlReq, SLOW_REQUEST_CONFIG);
        return retorno.data;
    }

    executarDownload(arquivo) {
        let a = window.document.createElement('a');
        a.href = window.URL.createObjectURL(new Blob(['\ufeff', arquivo], { type: 'text/csv;' }));
        a.download = `Relatório Gerencial de ${moment(this.state.dataInicio)
            .format('DD/MM/YYYY')} até ${moment(this.state.dataFim)
                .format('DD/MM/YYYY')}.csv`;

        document.body.appendChild(a);
        a.click();

        document.body.removeChild(a);
    }

    handleChangeTipoBusca(event) {
        this.setState({ tipoDataBusca: event.target.id });
    }

    render() {
        const {
            handleSubmit, submitting, invalid
        } = this.props;

        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN, getFinanceiroEmpresa(this.props.empresaSelecionada.id),
                getFinanceiroAgencia(this.props.empresaSelecionada.id)]}
            empresaSelecionada={this.props.empresaSelecionada}>
            <div className="container-padrao" style={{ height: '100%' }}>
                <Titulo texto="Relatório Gerencial Agência" urlRetorno="/menu-relatorio" />
                <form onSubmit={handleSubmit(this.buscar.bind(this))}>
                    <fieldset className='border col-12 justify-content-center' style={{ backgroundColor: '#FFF' }}>
                        <div className='mt-4'>
                            <Field type="checkbox" name='resumido' component={renderFieldCheck}
                                label="Resumido?"
                                css="form-check-input" readOnly={false} />
                        </div>
                        <div className='mt-n1'>
                            <Field type="checkbox" name='encomenda' component={renderFieldCheck}
                                label="Encomendas"
                                css="form-check-input" readOnly={false}
                            />
                        </div>
                        <div className='row mt-2 mb-2'>
                            <div className='col-md-2 col-12 col-sm-12'>
                                <span className="label-data">Buscar por</span>
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" id="tipoDataVenda"
                                        onChange={this.handleChangeTipoBusca}
                                        checked={this.state.tipoDataBusca === 'tipoDataVenda'} />
                                    <label className="form-check-label" htmlFor="tipoEmpresaAtual">
                                        Data de venda
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" id="tipoDataEmbarque"
                                        onChange={this.handleChangeTipoBusca}
                                        checked={this.state.tipoDataBusca === 'tipoDataEmbarque'} />
                                    <label className="form-check-label" htmlFor="tipoTodasEmpresa">
                                        Data de embarque
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" id="tipoDataEmbarqueFuturo"
                                        onChange={this.handleChangeTipoBusca}
                                        checked={this.state.tipoDataBusca === 'tipoDataEmbarqueFuturo'} />
                                    <label className="form-check-label" htmlFor="tipoDataEmbarqueFuturo">
                                        Data de embarque Futuro
                                    </label>
                                </div>
                            </div>
                            <div className='col-md-2 col-12 col-sm-12'>
                                <span className="label-data">De</span>
                                <DatePicker
                                    value={this.state.dataInicio}
                                    className='form-control form-control-lg campo-busca data-itinerario'
                                    locale="pt-BR"
                                    onChange={date => {
                                        this.setState({ dataInicio: date });
                                    }
                                    }
                                    selected={this.state.dataInicio}
                                    dateFormat="dd/MM/yyyy" />
                            </div>
                            <div className='col-md-2 col-12 col-sm-12'>
                                <span className="label-data ">Até</span>
                                <DatePicker
                                    className='form-control form-control-lg campo-busca data-itinerario'
                                    locale="pt-BR"
                                    value={this.state.dataFim}
                                    selected={this.state.dataFim}
                                    onChange={date => {
                                        this.setState({ dataFim: date });
                                    }
                                    }
                                    dateFormat="dd/MM/yyyy" />
                            </div>                            
                            {this.state.tipoRelatorio === 'EMPRESA' ? <div className='col-md-3 col-12 col-sm-12'>
                                <span className="label-dat">Empresa</span>
                                <div className='mt-1'>
                                    <Field id='empresa' name='empresa'
                                        component={this.exibirComboEmpresas.bind(this)} />
                                </div>
                            </div> : ''}                            
                             
                            {this.possuiPerfilVerComboxAgencia() ? <div className='col-md-3 col-12 col-sm-12'>
                                <span className="label-dat">Agencias</span>
                                <div className='mt-1'>
                                    <Field id='agencia' name='agencia'
                                        component={this.exibirComboAgenciasEmpresa.bind(this)} />
                                </div>
                            </div> : ''}
                        </div>
                        <div className='col-md-12 col-12 col-sm-12 text-center mb-4'>
                            <button
                                disabled={invalid || submitting
                                    || !this.state.dataInicio
                                    || !this.state.dataFim                                    
                                    || (this.state.tipoRelatorio === 'EMPRESA' && !this.state.empresasSelecionadas.length)
                                    || (this.possuiPerfilVerComboxAgencia() && !this.state.agenciasSelecionadas.length)
                                    || (this.possuiPerfilVerComboxAgencia() && !this.props.agenciasEmpresa.length)}
                                type="submit" className="btn btn-laranja">
                                Buscar
                            </button>
                        </div>
                    </fieldset>
                </form>
            </div>
        </Autorizacao>
        )
    }
}

export const mapStateToProps = state => (
    {
        empresas: state.empresas,
        empresaSelecionada: state.empresaSelecionada,
        agenciasEmpresa: state.agenciasEmpresa
    });

export default connect(mapStateToProps,
{ buscarEmpresas, buscarAgenciaEmpresa })(reduxForm({
    form: 'formRelatorioGerencialAgencia',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
})(PainelRelatorioGerencialAgencia));